export default "__VITE_ASSET__Cy1v54Il__"